import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function Privacy() {
  const { t } = useTranslation();

  return (
    <div className="bg-deepblack min-h-screen">
      <Navbar />
      <main>
        <section className="relative min-h-[35vh] md:min-h-[40vh] w-full flex items-end pb-16 md:pb-20 overflow-hidden bg-deepblack">
          <div className="absolute inset-0 z-0">
            <img
              src="https://readdy.ai/api/search-image?query=Soft%20warm%20ambient%20light%20illuminating%20a%20luxury%20music%20studio%20with%20elegant%20grand%20piano%20slightly%20out%20of%20focus%20in%20background%20deep%20black%20and%20champagne%20gold%20color%20palette%20minimalist%20cinematic%20composition%20intimate%20atelier%20atmosphere%20high%20contrast%20editorial%20photography%20no%20text%20no%20logos&width=1600&height=600&seq=privacy-hero-2026&orientation=landscape"
              alt="Privacy Policy"
              className="w-full h-full object-cover object-center opacity-50"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-deepblack/30 via-deepblack/50 to-deepblack" />
          </div>

          <div className="relative z-10 w-full px-6 md:px-12 lg:px-16">
            <span className="inline-block px-4 py-1.5 border border-marble/30 rounded-full text-marble/80 text-xs font-sans tracking-widest uppercase mb-5">
              {t("privacy.hero.label")}
            </span>
            <h1 className="text-marble font-serif text-4xl md:text-5xl lg:text-6xl font-light tracking-wide">
              {t("privacy.hero.title")}
            </h1>
          </div>
        </section>

        <section className="bg-midnight py-20 md:py-28">
          <div className="w-full px-6 md:px-12 lg:px-16 max-w-3xl mx-auto">
            <article className="prose-custom space-y-12 text-marble/70 text-sm md:text-base font-sans leading-relaxed">
              <div>
                <h2 className="text-marble font-serif text-xl md:text-2xl font-light tracking-wide mb-4">{t("privacy.section1.title")}</h2>
                <p className="mb-3">{t("privacy.section1.p1")}</p>
                <p>{t("privacy.section1.p2")}</p>
              </div>

              <div>
                <h2 className="text-marble font-serif text-xl md:text-2xl font-light tracking-wide mb-4">{t("privacy.section2.title")}</h2>
                <p className="mb-3">{t("privacy.section2.p1")}</p>
                <ul className="list-disc pl-5 space-y-2">
                  <li>{t("privacy.section2.li1")}</li>
                  <li>{t("privacy.section2.li2")}</li>
                  <li>{t("privacy.section2.li3")}</li>
                  <li>{t("privacy.section2.li4")}</li>
                </ul>
              </div>

              <div>
                <h2 className="text-marble font-serif text-xl md:text-2xl font-light tracking-wide mb-4">{t("privacy.section3.title")}</h2>
                <p className="mb-3">{t("privacy.section3.p1")}</p>
                <ul className="list-disc pl-5 space-y-2">
                  <li>{t("privacy.section3.li1")}</li>
                  <li>{t("privacy.section3.li2")}</li>
                  <li>{t("privacy.section3.li3")}</li>
                  <li>{t("privacy.section3.li4")}</li>
                </ul>
              </div>

              <div>
                <h2 className="text-marble font-serif text-xl md:text-2xl font-light tracking-wide mb-4">{t("privacy.section4.title")}</h2>
                <p>{t("privacy.section4.p1")}</p>
              </div>

              <div>
                <h2 className="text-marble font-serif text-xl md:text-2xl font-light tracking-wide mb-4">{t("privacy.section5.title")}</h2>
                <p className="mb-3">{t("privacy.section5.p1")}</p>
                <p>{t("privacy.section5.p2")}</p>
              </div>

              <div>
                <h2 className="text-marble font-serif text-xl md:text-2xl font-light tracking-wide mb-4">{t("privacy.section6.title")}</h2>
                <p className="mb-3">{t("privacy.section6.p1")}</p>
                <Link
                  to="/inquiry"
                  className="inline-flex items-center gap-2 text-champagne text-sm font-sans hover:text-marble transition-colors"
                >
                  <i className="ri-arrow-right-line" />
                  {t("privacy.section6.link")}
                </Link>
              </div>

              <div>
                <h2 className="text-marble font-serif text-xl md:text-2xl font-light tracking-wide mb-4">{t("privacy.section7.title")}</h2>
                <p>{t("privacy.section7.p1")}</p>
              </div>

              <div className="pt-8 border-t border-white/5">
                <p className="text-marble/40 text-xs font-sans">
                  {t("privacy.lastUpdated")}
                </p>
              </div>
            </article>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}